exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sentence[data-v-4e8c394c] {\r\n    display: block;\r\n    margin-bottom: 0.5em;\n}\n.mobile-alert .sentence[data-v-4e8c394c] {\r\n    margin-bottom: 1em;\n}\n.mobile-alert .btn[data-v-4e8c394c] {\r\n    margin: 0 auto;\r\n    display: block;\n}\r\n", ""]);

// exports
